import React from 'react';
import { useRouter } from 'next/router';
import { withTranslation } from 'utils/with-i18next';
import Logo from '../../assets/img/Logo';
import packageInfo from '../../../package.json';

function Footer({ t }) {
  const router = useRouter();
  const locale = router.locale || 'ko';

  // Determine policy page URLs based on locale
  const privacyUrl = locale === 'ko' ? '/policy/privacy' : `/policy/privacy-${locale}`;
  const serviceUrl = '/policy/service'; // Terms of Service is Korean-only

  return (
    <footer className="bg-black-08 w-full px-[5%] py-12 sm:py-16 relative font-bold border-t border-gray-700">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12">
          {/* Logo */}
          <div>
            <a id="logo-ff" className="block mt-[7px]" href="/">
              <Logo />
            </a>
          </div>

          {/* Menu */}
          <div>
            <h3 className="text-light-gray text-base sm:text-lg mb-3">{t('menu')}</h3>
            <ul className="space-y-2">
              <li>
                <a
                  id="link-guide3"
                  className="underLine text-xl sm:text-2xl hover:opacity-80 transition-opacity"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={t('link.guideUrl')}>
                  {t('link.guide')}
                </a>
              </li>
              <li>
                <a
                  id="link-upadteNote3"
                  className="underLine text-xl sm:text-2xl hover:opacity-80 transition-opacity"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={t('link.updateNoteUrl')}>
                  {t('link.updateNote')}
                </a>
              </li>
            </ul>
          </div>

          {/* Etc section */}
          <div>
            <ul className="flex flex-wrap gap-x-5 gap-y-2 sm:flex-row">
              <li>
                <a id="tu" className="underLine text-sm sm:text-base hover:opacity-80 transition-opacity" href={serviceUrl}>
                  {t('link.TermsofUse')}
                </a>
              </li>
              <li>
                <a id="pp" className="underLine text-sm sm:text-base hover:opacity-80 transition-opacity" href={privacyUrl}>
                  {t('link.PrivacyPolicy')}
                </a>
              </li>
              <li>
                <p className="text-sm sm:text-base text-gray-400">Made by dodlab Inc.</p>
              </li>
              <li>
                <p className="text-sm sm:text-base text-gray-400">v {`${packageInfo?.version} (${packageInfo?.lastUpdate})`}</p>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-light-gray text-base sm:text-lg mb-3">{t('contactUs')}</h3>
            <a
              id="mailto2"
              className="btn btn-small inline-block mt-2 hover:opacity-80 transition-opacity"
              href="mailto:cs@bgms.live?subject=[BGMs] Inquiry email">
              {t('link.emailUs')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default withTranslation('common')(Footer);
